import Model, { attr, belongsTo } from '@ember-data/model';

import StakeholderValidations from 'register-partners-js/validations/stakeholder';

export default class Stakeholder extends Model.extend(StakeholderValidations) {
  @attr('boolean') owner;
  @attr() phoneNumber;
  @attr() kycProviderName;
  @attr('boolean', { allowNull: true }) taxPayerOutsideLegalCountry;
  @attr('boolean', { allowNull: true }) usTaxPayer;
  @attr('string', { allowNull: true, defaultValue: null }) otherTaxResidencyCountry;
  @attr('string', { allowNull: true, defaultValue: null }) otherTaxIdentificationNumber;
  @attr('boolean', { allowNull: true, defaultValue: null }) usPerson;
  @attr('string', { allowNull: true, defaultValue: null }) usTaxIdentificationNumber;
  @attr('boolean', { allowNull: true, defaultValue: null }) selfPepDeclaration;

  @belongsTo('organization', { async: false, inverse: 'stakeholder' }) organization;
  @belongsTo('kycSdkToken', { async: false, inverse: 'stakeholder' }) kycSdkToken;
}
